// @flow
import React from 'react'
import I18n from 'i18n-react'

// components
import { FieldForm, Popover } from '../../Components/'
import { Bool } from '../../Components/_formFields'

const DiscountDrivingLicenceContent = {
  types: {
    CarGenerali: {
      types: {
        'CarGenerali_drivingLicence': {
          fieldNames: {
            issueDate: 'Datum vystavení',
            drivingLicenceBSince: 'Rok ke skupině B'
          },
          fieldOrder: [
            'issueDate',
            'drivingLicenceBSince'
          ],
          components: {
            issueDate: {
              name: 'dateInputs'
            }
          }
        }
      },
      fieldNames: {
        drivingLicence: ''
      },
      fieldOrder: [
        'drivingLicence'
      ],
    },
  },
  fieldOrder: [
    'CarGenerali'
  ],
  fieldNames: {
    CarGenerali: ''
  },
}

// types
import type { DefaultMiniAppProps } from './'
import type { ExpandedSpecificationDTO } from '../../Core/Types/Field'
import type { FormValueType } from '../../Core/Types/Values'

type DiscountsMiniAppProps = DefaultMiniAppProps & {
  inputHelps: Object,
  miniAppData: {
    discounts: { [key: string]: any },
    setDiscounts: (discounts: { [key: string]: any }) => void,
    discountSpecification: ExpandedSpecificationDTO,
    discountValidationErrors: Object,
  }
}

export default class DiscountsMiniApp extends React.Component<DiscountsMiniAppProps> {
  static defaultProps = {
    isBackOffice: false,
  }

  shouldComponentUpdate(nextProps: DiscountsMiniAppProps) {
    return JSON.stringify(nextProps.miniAppData) !== JSON.stringify(this.props.miniAppData) ||
      nextProps.pushIsPristine !== this.props.pushIsPristine
  }

  handleOnChange = (key: string, value: boolean) => {
    if (this.props.miniAppData.discounts && typeof this.props.miniAppData.setDiscounts === 'function') {
      let discounts = this.props.miniAppData.discounts
      this.props.miniAppData.setDiscounts(
        Object.keys(discounts).reduce((discountsAcc, discountKey) => {
          discountsAcc = discountsAcc.setIn([discountKey, key], value)
          return discountsAcc
        }, this.props.miniAppData.discounts)
      )
    }
  }

  handleOnChangeValue = (key: string, value: FormValueType, pathArray: Array<string>) => {
    this.props.miniAppData.setDiscounts(this.props.miniAppData.discounts.setIn(pathArray, value))
  }

  render() {
    const { isBackOffice, miniAppData, pushIsPristine, inputHelps } = this.props
    if (!isBackOffice || !miniAppData.discounts || !Object.keys(miniAppData.discounts).length || !miniAppData.discountSpecification ||
      !inputHelps) {
      return null
    }

    const checkBoxes = [
      'isDoctor', 'isExperience', 'youngRiderComplicity'
    ]

    const values = {
      isDisabled: false,
      isDoctor: false,
      drivingLicenceDiscount: false,
      youngRiderComplicity: false,
      isExperience: false,
    }
    Object.keys(miniAppData.discounts).map((discountKey) => {
      values.isDisabled = values.isDisabled || miniAppData.discounts.getIn([discountKey, 'isDisabled'], false)
      values.isDoctor = values.isDoctor || miniAppData.discounts.getIn([discountKey, 'isDoctor'], false)
      values.drivingLicenceDiscount = values.drivingLicenceDiscount ||
        miniAppData.discounts.getIn([discountKey, 'drivingLicenceDiscount'], false)
      values.youngRiderComplicity = values.youngRiderComplicity || miniAppData.discounts.getIn([discountKey, 'youngRiderComplicity'], false)
      values.isExperience = values.isExperience || miniAppData.discounts.getIn([discountKey, 'isExperience'], false)
    })

    return ([
        <div className='text-center mt-5' key='discountCheckboxes'>
          <h2>{I18n.translate('components.discounts.title')}</h2>
        </div>,
        <hr className='border-0 border-sm-top border-active-object' key='discountCheckboxes-hr'/>,
        checkBoxes.map<Object>((fieldName) => (
          <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-top' key={`formGroup-${fieldName}`}>
            <div className='col-12 col-sm-5 offset-sm-4 mb-3'>
              <Bool
                enabled
                id={`DiscountsMiniApp-${fieldName}`}
                isPristine
                key={fieldName}
                label={I18n.translate(`components.discounts.values.${fieldName}`)}
                name={fieldName}
                onChange={(value) => {
                  this.handleOnChange(fieldName, value)
                }}
                prefix='discountsMiniApp-'
                validationErrors={{}}
                value={values[fieldName]}
              />
            </div>
            {!!inputHelps[fieldName] &&
            <Popover
              content={inputHelps[fieldName].content}
              id={`DiscountsMiniApp-${fieldName}-helper`}
              title={inputHelps[fieldName].title}
            />
            }
          </div>
        )),
        values.drivingLicenceDiscount
          ? <FieldForm
            blockClassName=''
            blockClassNameForR=''
            blockContentClassName=''
            content={DiscountDrivingLicenceContent}
            data={miniAppData.discounts}
            formData={miniAppData.discounts}
            key='discountFieldForm'
            onChangeValue={this.handleOnChangeValue}
            pushIsPristine={pushIsPristine}
            showBlockTitle={false}
            specification={miniAppData.discountSpecification}
            validationErrors={miniAppData.discountValidationErrors}
          />
          : null
      ]
    )
  }
}
